module.exports = __webpack_public_path__ + "img/2025-0411-01-02.a0987a04.png";